import http from "./http";

/* =========================
   GET CALLS REPORT (GENERIC)
========================= */
export const getCallsWithParams = async (params = {}) => {
  try {
    const res = await http.get("/calls_report", { params });
    return res.data;
  } catch (error) {
    console.error("Calls Report Error:", error.response?.data || error);
    return { status: "error", data: [], summary: {} };
  }
};